import { WalletKyc } from '../../../schemas/wallet-kyc-schema';
import { request } from '../../../utils/request';

export interface CorporateCreationResponse {
  success: boolean;
  customer_id: number;
  kyc_profile_id: number;
  entity_id: number;
  sterling_customer_id: string;
  next_steps: string[];
  message: string;
}

type newAddressSchema = {
  street: string;
  street_line_2?: string;
  city: string;
  state: string;
  postal_code?: string;
  country: string;
  lga?: string;
};

type addressChoiceSchema = {
  type: 'new' | 'saved';
  saved_address_id?: number;
  new_address?: newAddressSchema;
};

export default function (
  formData: Omit<WalletKyc, 'directors' | 'customer_id' | 'address_choice'> & {
    address_choice: addressChoiceSchema;
  },
  authToken: string
): Promise<CorporateCreationResponse> {
  return request({
    url: '/sterling/kyc/corporate',
    method: 'POST',
    formData,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
}
